module.exports = __webpack_public_path__ + "img/電気回路_3_1_5.3bf52636.png";